// Export BannerTitle (same as AlertTitle)
import {
  AlertTitle,
  type AlertTitleProps,
} from 'src/components/AlertTitle/AlertTitle';
export const BannerTitle = AlertTitle;
export type BannerTitleProps = AlertTitleProps;
